import React from 'react';
import { black, primary, white } from '@/constants/Colors';
import { OpcionTopNavigation } from '@/objects/Menus';

interface TopNavigationProps {
    opciones: OpcionTopNavigation[];
    opcionActual: string;
    setOpcionActual: (opcion: string) => void;
    style?: React.CSSProperties;
}

function TopNavigation({ opciones, opcionActual, setOpcionActual, style }: TopNavigationProps) {
    return (
        <div
            style={{
                width: '100%',
                backgroundColor: white,
                borderRadius: '12px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                ...style,
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'stretch',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    scrollbarWidth: 'thin',
                    borderRadius: '12px',
                }}
            >
                {opciones.map((opcion, index) => {
                    const activa = opcionActual === opcion.tipoOpcion;

                    return (
                        <button
                            key={`${opcion.nombre}-${index}`}
                            type="button"
                            onClick={() => setOpcionActual(opcion.tipoOpcion)}
                            style={{
                                height: '100%',
                                minWidth: '150px',
                                padding: '0 16px',
                                border: 'none',
                                borderBottom: `3px solid ${activa ? primary : 'transparent'}`,
                                background: 'transparent',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                color: activa ? primary : black,
                                fontWeight: activa ? 700 : 500,
                                whiteSpace: 'nowrap',
                                transition: 'all 180ms ease',
                                flexShrink: 0,
                            }}
                        >
                            {opcion.icono && (
                                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {opcion.icono}
                                </span>
                            )}
                            <span>{opcion.nombre}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default TopNavigation;